<template>
  <div class="card goal-view">
    <div class="card-header pb-0">
      <div class="d-flex justify-content-between">
        <div class="flex-grow-1">
          <p class="square-after f-w-600">Total Imágenes<i class="fa fa-circle"></i></p>
          <h4>Productos Ingresados en Super kompras va</h4>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <ul>
        <li>
          <router-link :to="{ name: 'productos-app', query: { foto: 'TODAS' } }" class="goal-link">
            <span class="f-w-600 header-text-primary">Total Productos</span>
            <h4 class="f-w-700 header-text-primary">{{ formatear(app?.totalProductos) }}</h4>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'productos-app', query: { foto: 'NO' } }" class="goal-link">
            <span class="f-w-600">Productos sin Foto en la APP</span>
            <h4 class="f-w-700">{{ formatear(app?.productosSinFoto) }}</h4>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'productos-app', query: { foto: 'SI' } }" class="goal-link">
            <span class="f-w-600">Productos con Foto en la APP</span>
            <h4 class="f-w-700">{{ formatear(app?.productosConFoto) }}</h4>
          </router-link>
        </li>
      </ul>
      <p v-if="!cargando && !app" class="text-center text-muted small mt-3 mb-0">
        No se pudo obtener la información de la APP.
      </p>
    </div>
    <div class="card-body d-flex flex-column align-items-center justify-content-center">
      <div class="goal-chart">
        <div class="shap-block">
          <div class="rounded-shap animate-bg-secondary">
            <i></i><i></i><i></i>
          </div>
        </div>
        <div id="goal">
          <goalChart :percentage="porcentaje" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goalChart from "./goalChart.vue";

export default {
  name: "GoalView",
  components: { goalChart },
  props: {
    // { totalProductos, productosConFoto, productosSinFoto } del catálogo de la APP, o null
    app: { type: Object, default: null },
    cargando: { type: Boolean, default: false },
  },
  computed: {
    porcentaje() {
      const total = this.app?.totalProductos;
      if (!total) return 0;
      return Number(((this.app.productosConFoto / total) * 100).toFixed(2));
    },
  },
  methods: {
    formatear(n) {
      return n == null ? "—" : Number(n).toLocaleString();
    },
  },
};
</script>

<style scoped>
.goal-chart {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.shap-block,
#goal {
  margin: -15px 0;
}
.goal-link {
  display: block;
  color: inherit;
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.goal-link:hover {
  opacity: 0.8;
  transform: translateY(-2px);
}
</style>
